import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { AutoCompleteSliceReducer, authReducer, headerReducer, LangReducer } from "./Services/index";

const rootReducer = combineReducers({
    auth: authReducer,
    AutoComplete: AutoCompleteSliceReducer,
    header: headerReducer,
    lang: LangReducer,
});

export const store = configureStore({ reducer: rootReducer });